import { FC } from 'react';
import classNames from 'classnames';
import { IBaseField } from '.';
import { FieldControl } from 'src/UI';
import { useTextAreaAutoHeight } from 'src/Hooks';
import st from './Control.module.scss';

interface ITextAreaProps extends IBaseField {
	/** Количество строк ( по умолчанию - 1 ) */
	rows?: number;
	/** Подстраивать высоту инпута автоматически */
	isAutoHeight?: boolean;
}

/**
 * Текстовое поле
 */
const TextArea: FC<ITextAreaProps> = (props) => {
	const {
		name,
		title,
		isRequired = false,
		disabled = false,
		placeholder,
		isAutoHeight = false,
		value,
		touched = false,
		error,
		onChange,
		onBlur,
		rows = 1,
		size = 'ns',
		maxLength,
	} = props;

	const inputRef = useTextAreaAutoHeight(value, isAutoHeight);

	const inputClasses = classNames(st.input, st[size], {
		[st.inValidate]: touched && error,
	});

	return (
		<FieldControl
			name={name}
			title={title}
			isRequired={isRequired}
			isInvalid={!!touched && !!error}
			isTouched={!!touched}
			errorMsg={error}
			notFixedHeight
		>
			<textarea
				ref={inputRef}
				name={name}
				rows={rows}
				value={value ?? ''}
				onChange={onChange}
				onBlur={onBlur}
				placeholder={placeholder}
				className={inputClasses}
				disabled={disabled}
				maxLength={maxLength}
			/>
		</FieldControl>
	);
};

export default TextArea;
